import * as D from '../../utilities/Drawer'
import * as D2 from '../../utilities/Drawer2'
import { formatNumDossier } from '../depannage/depFicheUtils'
import { getLieuAffichage } from '../../utilities/depLieux'
import jsPDF from 'jspdf'
import {
    width
} from '../../utilities/Drawer'

export const mx = 5, mxb = 15, my = 5
export const margin = (width - 2 * mx - 2 * mxb) / 3
export const halfMargin = (margin - mx) / 2
export const quartMargin = (width - 3 * mx - 2 * mxb) / 4
export const sixMargin = (2 * quartMargin - mx) / 3
export const x00 = mxb
export const x01 = x00 + halfMargin + mx
export const x10 = x01 + halfMargin + mx
export const x11 = x10 + halfMargin + mx
export const x20 = x11 + halfMargin + mx
export const x21 = x20 + halfMargin + mx
export const infoWidth = margin + halfMargin + mx
let mt
let addMt = 15, tfH = 8

// A2 (CDC 16.10) : lieu / destination lus comme sur la fiche (POI nommé,
// adresse, GPS ; texte de l'import en dernier recours) — l'ancien `ligne_0`
// n'existe plus sur le POI sérialisé, les deux champs sortaient vides.
const lieuTexte = (po) => {
    const aff = getLieuAffichage(po, po ? [po.ligne_0, po.ligne_1, po.ligne_2] : [])
    return aff ? aff.lines.join(', ') : ''
}

export function depFiche(dep, employes, depanneuses, mdps) {
    const APPEL_LABELS = { 0: 'Assurance', 1: 'Police', 2: 'Privé' }
    const doc = new jsPDF('p', 'mm', [297, 210])
    doc.setFont('times')
    if (dep.four || dep.appel_type === 1) {
        D.watermarkCleFour(doc, dep.four, dep.avec_cle === 1)
    }
    // Title
    D2.drawTitle(doc, 'Fiche Dépannage', mxb)
    mt = 30
    D.textBig(doc, 'Informations', width / 2, mt, 'center')
    mt += 10
    // Line 1
    D2.drawTextField2(doc, 'Date', dep.date, x00, mt, halfMargin)
    D2.drawTextField2(doc, 'Heure', dep.heure, x01, mt, halfMargin)

    // GE-58 : l'assistance seulement pour un appel Assistance (0).
    D2.drawTextField2(doc, 'Appel', (dep.appel_type === 0 && dep.assistance_entite_label) || APPEL_LABELS[dep.appel_type] || '', x10, mt, halfMargin)
    D2.drawTextField2(doc, 'Dépanneur', dep.depanneur === 0 ? '' : (employes.find(emp => emp.id === dep.depanneur) || {}).nom || '', x11, mt, halfMargin)

    D2.drawTextField2(doc, 'Matricule', dep.matricule, x20, mt, halfMargin)
    D2.drawTextField2(doc, 'Châssis', dep.chassis, x21, mt, halfMargin)

    // Line 2
    mt += addMt
    D2.drawTextField2(doc, 'Lieu', lieuTexte(dep.lieu_intervention), x00, mt, margin)

    D2.drawTextField2(doc, 'Destination', dep.surPlace ? 'Sur place' : lieuTexte(dep.destination_finale), x10, mt, margin + halfMargin + mx)

    // Line 3
    mt += addMt
    D2.drawTextField2(doc, 'Marque', dep.marque, x00, mt, halfMargin)
    D2.drawTextField2(doc, 'Modèle', dep.modele, x01, mt, halfMargin)

    D2.drawTextField2(doc, 'Plaques', dep.plaques, x10, mt, halfMargin)
    // A2 : la dépanneuse prend la place de l'ancienne case « SVP méca » (un
    // nom de camion long débordait, centré, sur les plaques).
    D2.drawTextField2(doc, 'Dépanneuse', dep.vehicule_depannage === 0 ? '' : (depanneuses.find(ve => ve.id === dep.vehicule_depannage) || {}).nom || '', x11, mt, margin + halfMargin + mx)

    // A2 : cases « Fourrière » / « SVP méca » retirées (mortes : la
    // fourrière est en filigrane, svpMeca n'est plus tenu par la V2).

    // Line 4
    mt += addMt
    D2.drawTextField2(doc, 'Nom', dep.nom, x00, mt, margin)

    D2.drawTextField2(doc, 'Prénom', dep.prenom, x10, mt, margin)

    D2.drawTextField2(doc, 'Tél', dep.telephone, x20, mt, margin)

    // Line 5
    mt += addMt
    D2.drawTextField2(doc, 'Assurance', dep.assurance, x00, mt, margin)

    D2.drawTextField2(doc, 'N° dossier', formatNumDossier(dep.num_dossier), x10, mt, margin)

    let strcle = ''
    if (dep.avec_cle === 1) strcle = 'Avec clé'
    else if (dep.avec_cle === 2) strcle = 'Sans clé'
    D.textNormalBoldHigher(doc, strcle, x20 + (halfMargin + mx), mt + 5, 'center')

    // Sinitres
    let showSinistre = (dep.assuranceSinistre !== '' || dep.numSinistre !== '' || parseFloat(dep.franchise) !== 0 || parseFloat(dep.rabaisFranchise) !== 0 || dep.couvLocation !== '')
    let showFautif = (dep.fautifNom !== '' || dep.fautifVoiture !== '' || dep.fautifPlaques !== '' || dep.fautifAssurance !== '')
    let showExpertise = (dep.expertDate !== '' || dep.expertDateEffective !== '' || dep.expertNom !== '')
    let showCleSupp = (parseFloat(dep.cleSupp) !== 0 || dep.infoCleSupp !== '')
    let showCGPlaques = (dep.carteGrise || dep.carteGriseDate !== '' || dep.infoCarteGrise !== '' || dep.avecPlaques || dep.plaquesReprisLe !== '' || dep.infoAvecPlaques !== '')
    let showAutre = (dep.effetsPers !== '' || dep.polAutre !== '')
    let showSinistres = showSinistre || showFautif || showExpertise || showCleSupp || showCGPlaques || showAutre
    if (showSinistres) {
        mt += addMt
        D.textBig(doc, 'Sinistres', width / 2, mt, 'center')
        mt += 5
    }
    if (showSinistre) {
        D.textTitle(doc, 'Sinistre', mxb, mt, 'left')
        mt += 5
        D2.drawTextField2(doc, 'Assurance', `${dep.assuranceSinistre}`, x00, mt, quartMargin)
        D2.drawTextField2(doc, 'Num. sinistre', `${dep.numSinistre}`, x00 + quartMargin + mx, mt, quartMargin)

        D2.drawTextField2(doc, 'Franchise', `${dep.franchise}`, x00 + 2 * (quartMargin + mx), mt, sixMargin)
        D2.drawTextField2(doc, 'Rabais franchise', `${dep.rabaisFranchise}`, x00 + 2 * (quartMargin + mx) + sixMargin + mx, mt, sixMargin)
        D2.drawTextField2(doc, 'Couv. location', `${dep.couvLocation}`, x00 + 2 * (quartMargin + mx) + 2 * (sixMargin + mx), mt, sixMargin)
        mt += addMt
    }
    if (showFautif) {
        D.textTitle(doc, 'Fautif', mxb, mt, 'left')
        mt += 5
        D2.drawTextField2(doc, 'Nom', `${dep.fautifNom}`, x00, mt, quartMargin)
        D2.drawTextField2(doc, 'Voiture', `${dep.fautifVoiture}`, x00 + quartMargin + mx, mt, quartMargin)
        D2.drawTextField2(doc, 'Plaques', `${dep.fautifPlaques}`, x00 + 2 * (quartMargin + mx), mt, quartMargin)
        D2.drawTextField2(doc, 'Assurance', `${dep.fautifAssurance}`, x00 + 3 * (quartMargin + mx), mt, quartMargin)
        mt += addMt
    }
    if (showExpertise) {
        D.textTitle(doc, 'Expertise', mxb, mt, 'left')
        mt += 5
        D2.drawTextField2(doc, 'Date prévue', `${dep.expertDate}`, x00, mt, quartMargin)
        D2.drawTextField2(doc, 'Date passage', `${dep.expertDateEffective}`, x00 + quartMargin + mx, mt, quartMargin)
        D2.drawTextField2(doc, 'Expert', `${dep.expertNom}`, x00 + 2 * (quartMargin + mx), mt, quartMargin)
        mt += addMt
    }
    if (showCleSupp) {
        D.textTitle(doc, 'Clé supp.', mxb, mt, 'left')
        mt += 5
        D2.drawTextField2(doc, 'Clé supp.', `${dep.cleSupp}`, x00, mt, quartMargin)
        let n, lines = 0
        if (dep.infoCleSupp !== 0) {
            D.textNormalBold(doc, 'Infos', x00 + quartMargin + mx, mt, 'left')
            n = dep.infoCleSupp
            mt += 5
            lines = doc.splitTextToSize(n, 140)
            for (let y = 0; y < lines.length; y++) {
                if (y > 0) mt += 4
                D.textNormal(doc, lines[y], x00 + quartMargin + mx, mt, 'left')
            }
        }
        if (lines <= 1) mt += 10
        else mt += 10
    }
    if (showCGPlaques) {
        D.textTitle(doc, 'CG + Plaques', mxb, mt, 'left')
        mt += 5
        D.drawTextRect(doc, 'Carte grise', x00, mt, quartMargin, tfH, dep.carteGrise)
        D2.drawTextField2(doc, 'Reprise le', `${dep.carteGriseDate}`, x00 + mx + quartMargin, mt, quartMargin)
        let n, lines = 0
        if (dep.infoCarteGrise !== 0) {
            D.textNormalBold(doc, 'Infos', x00 + 2 * (quartMargin + mx), mt, 'left')
            n = dep.infoCarteGrise
            mt += 5
            lines = doc.splitTextToSize(n, 95)
            for (let y = 0; y < lines.length; y++) {
                if (y > 0) mt += 4
                D.textNormal(doc, lines[y], x00 + 2 * (quartMargin + mx), mt, 'left')
            }
        }
        if (lines <= 1) mt += 10
        else mt += 10
        D.drawTextRect(doc, 'Plaques', x00, mt, quartMargin, tfH, dep.avecPlaques)
        D2.drawTextField2(doc, 'Reprises le', `${dep.plaquesReprisLe}`, x00 + mx + quartMargin, mt, quartMargin)
        if (dep.infoAvecPlaques !== 0) {
            D.textNormalBold(doc, 'Infos', x00 + 2 * (quartMargin + mx), mt, 'left')
            n = dep.infoAvecPlaques
            mt += 5
            lines = doc.splitTextToSize(n, 95)
            for (let y = 0; y < lines.length; y++) {
                if (y > 0) mt += 4
                D.textNormal(doc, lines[y], x00 + 2 * (quartMargin + mx), mt, 'left')
            }
        }
        if (lines <= 1) mt += 10
        else mt += 10
    }
    if (showAutre) {
        D.textTitle(doc, 'Autre', mxb, mt, 'left')
        mt += 5
        D2.drawTextField2(doc, 'Effets pers.', `${dep.effetsPers}`, x00, mt, quartMargin)
        let n, lines = 0
        if (dep.polAutre !== 0) {
            D.textNormalBold(doc, 'Infos', x00 + quartMargin + mx, mt, 'left')
            n = dep.polAutre
            mt += 5
            lines = doc.splitTextToSize(n, 140)
            for (let y = 0; y < lines.length; y++) {
                if (y > 0) mt += 4
                D.textNormal(doc, lines[y], x00 + quartMargin + mx, mt, 'left')
            }
        }
        if (lines <= 1) mt += 10
        else mt += 10
    }
    if (!showSinistres) mt += addMt

    // Tarifs
    let neededHeight = 5 * addMt + dep.autres.length * addMt + 5
    if (D.height - mt < neededHeight + my) {
        doc.addPage()
        mt = 15
    }
    mt += 5
    let cadreTarifY0 = mt - 7, cadreTarifX0 = width / 2, cadreTarifY1 = mt, cadreTarifX1 = cadreTarifX0 + halfMargin + 5
    D.textBig(doc, 'Tarifs', width / 2 + (halfMargin + 4) / 2, mt, 'center')
    mt += 10
    cadreTarifY1 += 10
    // Line 1
    D2.drawTextField2(doc, 'Tarif de base', `${dep.baseTot}`, x11, mt, halfMargin)

    // Line 2
    mt += addMt
    cadreTarifY1 += addMt
    D2.drawTextField2(doc, 'Heures', `${dep.hSupQ}`, x00, mt, halfMargin)
    D.textNormal(doc, 'Supplémentaires à', x01 + halfMargin / 2, mt, 'center')

    D2.drawTextField2(doc, 'Tarif 1h', `${dep.hSupT}`, x10, mt, halfMargin)
    D2.drawTextField2(doc, 'Sous-total', `${dep.hSupTot}`, x11, mt, halfMargin)

    if (dep.hSupInfo !== '') D2.drawTextField2(doc, 'Info. heures supp.', dep.hSupInfo, x20, mt, margin)

    // Line 3
    mt += addMt
    cadreTarifY1 += addMt
    D2.drawTextField2(doc, 'Jours gard.', `${dep.gardQ}`, x00, mt, halfMargin)
    D.textNormal(doc, 'à', x01 + halfMargin / 2, mt, 'center')

    D2.drawTextField2(doc, 'Tarif gard.', `${dep.gardT}`, x10, mt, halfMargin)
    D2.drawTextField2(doc, 'Sous-total', `${dep.gardTot}`, x11, mt, halfMargin)

    if (dep.hSupInfo !== '') D2.drawTextField2(doc, 'Info. gardiennage', dep.gardInfo, x20, mt, margin)

    // Line 4
    dep.livraisons.forEach(livraison => {
        if (livraison.date !== '' || livraison.employe !== 0 || livraison.tot !== 0 || livraison.info !== '' || livraison.heure !== '' || livraison.vehicule !== 0) {
            if (D.height - mt < 30) {
                doc.addPage()
                mt = 0
            }
            mt += addMt
            cadreTarifY1 += addMt
            D2.drawTextField2(doc, 'Dest. livraison', livraison.info, x00, mt, infoWidth)
            D2.drawTextField2(doc, 'Livraison', `${livraison.tot}`, x11, mt, halfMargin)

            D2.drawTextField2(doc, 'Date livraison', `${livraison.date}`, x20, mt, halfMargin)
            D2.drawTextField2(doc, 'Livré par', livraison.employe === 0 ? '' : (employes.find(emp => emp.id === livraison.employe) || {}).nom || '', x21, mt, halfMargin)

            // D2.drawTextField2(doc, 'Dest. livraison', livraison.livInfo, x20, mt, margin)
            mt += addMt
            cadreTarifY1 += addMt

            D2.drawTextField2(doc, 'Heure livraison', `${livraison.heure}`, x20, mt, halfMargin)
            D2.drawTextField2(doc, 'Véhicule liv.', livraison.vehicule === 0 ? '' : depanneuses.find(veh => veh.id === livraison.vehicule).nom, x21, mt, halfMargin)
        }
    })

    // Fournitures terrain (AtelierLignes de la fiche) — montant TTC (prix HT
    // converti avec la TVA de la fiche), comme le décompte de la carte Tarifs.
    ;(dep.atelierLignes || []).forEach(four => {
        if (D.height - mt < 30) {
            doc.addPage()
            mt = 0
        }
        mt += addMt
        cadreTarifY1 += addMt
        const quantite = parseFloat(four.quantite) || 0
        const prixVente = parseFloat(four.prixVente) || 0
        let montant = quantite * prixVente
        if (four.isHT) montant = montant * (1 + dep.tva / 100)
        montant = Math.round(montant * 100) / 100
        D2.drawTextField2(doc, 'Fourniture', `${four.label} — ${quantite} × ${prixVente}`, x00, mt, infoWidth)
        D2.drawTextField2(doc, 'Montant', `${montant}`, x11, mt, halfMargin)
    })

    // Line 5
    for (let i = 0; i < dep.autres.length; i++) {
        if (D.height - mt < 30) {
            doc.addPage()
            mt = 0
        }
        mt += addMt
        cadreTarifY1 += addMt
        D2.drawTextField2(doc, 'Autre', `${dep.autres[i].total}`, x11, mt, halfMargin)

        if (dep.autres[i].info !== '') D2.drawTextField2(doc, 'Info. autre', dep.autres[i].info, x00, mt, infoWidth)
    }

    // Line 6
    if (dep.restiDate !== '' || dep.restiReprisPar !== '' || dep.restiHeure !== '') {
        mt += addMt
        cadreTarifY1 += addMt
        if (dep.restiInfo !== '') D2.drawTextField2(doc, 'Info. restitution', dep.restiInfo, x00, mt, infoWidth)
        else {
            D2.drawTextField2(doc, 'Repris par', `${dep.restiReprisPar}`, x00, mt, halfMargin)
            D2.drawTextField2(doc, 'Date restitution', `${dep.restiDate}`, x01, mt, halfMargin)
            D2.drawTextField2(doc, 'Heure restitution', `${dep.restiHeure}`, x10, mt, halfMargin)
        }

        D2.drawTextField2(doc, 'Restitution', `${dep.restiTot}`, x11, mt, halfMargin)
        if (dep.restiInfo !== '') {
            mt += addMt
            cadreTarifY1 += addMt
            D2.drawTextField2(doc, 'Repris par', `${dep.restiReprisPar}`, x00, mt, halfMargin)
            D2.drawTextField2(doc, 'Date restitution', `${dep.restiDate}`, x01, mt, halfMargin)
            D2.drawTextField2(doc, 'Heure restitution', `${dep.restiHeure}`, x10, mt, halfMargin)
        }


        //D2.drawTextField2(doc, 'Heure livraison', `${dep.livHeure}`, x01 + halfMargin / 2, mt, halfMargin)
    }

    // Line 7
    mt += addMt
    cadreTarifY1 += addMt + 10
    D2.drawTextField2(doc, 'Total', `${dep.totalFinal}`, x11, mt, halfMargin, true, true)
    doc.setLineWidth(.1)
    doc.line(cadreTarifX0, cadreTarifY0, cadreTarifX0, cadreTarifY1)
    doc.line(cadreTarifX0, cadreTarifY0, cadreTarifX1, cadreTarifY0)
    doc.line(cadreTarifX1, cadreTarifY0, cadreTarifX1, cadreTarifY1)
    doc.line(cadreTarifX0, cadreTarifY1, cadreTarifX1, cadreTarifY1)
    D.drawTextRect(doc, 'Sur place', x20, mt, halfMargin, tfH, dep.surPlace)
    D.drawTextRect(doc, 'Marquer', x21, mt, halfMargin, tfH, dep.marked)
    mt += addMt
    // Line 8
    if (dep.notes.find(note => note.print && note.text !== '')) {
        let neededHeightNotes = 0
        dep.notes.forEach(note => {
            if (note.print && note.text !== '') {
                let temp = [...doc.splitTextToSize(note.text, 170)]
                neededHeightNotes += temp.length * 4
            }
        })
        if (D.height - mt < neededHeightNotes + 25) {
            doc.addPage()
            mt = addMt
        }
        // mt += addMt
        D.textBig(doc, 'Notes', width / 2, mt, 'center')
        dep.notes.filter(note => note.print && note.text !== '').forEach(note => {
            doc.line(mxb, mt + 2, width - mxb, mt + 2)
            let tempMt = mt
            mt += 3
            let splitNote = doc.splitTextToSize(note.text, 170)
            splitNote.forEach(sNote => {
                mt += 4
                doc.text(sNote, mxb + 5, mt, 'left')
                //D.textNormal(doc, sNote, mxb + 5, mt, 'left')
            })
            doc.line(mxb, tempMt + 2, mxb, mt + 4)
            doc.line(width - mxb, tempMt + 2, width - mxb, mt + 4)
            doc.line(mxb, mt + 4, width - mxb, mt + 4)
            mt += 10
        })
    }

    // Line 9 — transactions = TransactionV2 (payé par en select, « reçu
    // par »/adresse du legacy vivent dans details).
    let transToPrint = (dep.transactionsv2 || []).filter(trans => parseFloat(trans.total) > 0)
    if (transToPrint.length > 0) {
        if (D.height - mt < transToPrint.length * 10 + 15) {
            doc.addPage()
            mt = 10
        }
        mt += 5
        D.textBig(doc, 'Transactions', width / 2, mt, 'center')
        mt += 7
        transToPrint.forEach(trans => {
            D2.drawTextField2(doc, 'Moy. paiement', mdps.find(mdp => mdp.id === trans.moyenPaie) ? mdps.find(mdp => mdp.id === trans.moyenPaie).nom : '', x00, mt, halfMargin)
            // GE-58 : payeur assistance d'un encaissement terrain (partenaire / libre).
            // GE-60 : « Assistance » en dépannage (valeur inchangée).
            const payePar = ['Assistance', 'Client', 'Perte'][trans.payeParSelect] || ''
            D2.drawTextField2(doc, 'Payé par', trans.payeur_label ? `${payePar} (${trans.payeur_label})` : payePar, x01, mt, halfMargin)
            D2.drawTextField2(doc, 'Détails', trans.details || '', x10, mt, margin)
            D2.drawTextField2(doc, 'Caissier', employes.find(employe => employe.id === trans.caissier) ? employes.find(employe => employe.id === trans.caissier).nom : '', x20, mt, halfMargin)
            D2.drawTextField2(doc, 'Tarif', trans.total.toString(), x21, mt, halfMargin)
            mt += addMt
        })
    }



    // // Line 1
    // D2.drawTextField2(doc, 'Date', dep.date, x00, mt, halfMargin)
    // D2.drawTextField2(doc, 'Heure', dep.heure, x01, mt, halfMargin)

    // D2.drawTextField2(doc, 'Appel', 'appel', x10, mt, halfMargin)
    // D2.drawTextField2(doc, 'Dépanneur', 'dep', x11, mt, halfMargin)

    // D2.drawTextField2(doc, 'Tél', dep.tel, x20, mt, margin)

    doc.save(`dep_${dep.date}_${dep.heure.replace(':', 'h')}.pdf`)
}
